import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Search } from "lucide-react";
import { api } from "../lib/api";
import { money, fmtDate, customerName } from "../lib/format";
import { PageHeader } from "../components/PageHeader";
import { StatusBadge } from "../components/StatusBadge";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

const FILTERS = ["", "draft", "sent", "approved", "declined"];

export default function Quotes() {
  const [list, setList] = useState([]);
  const [status, setStatus] = useState("");
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  useEffect(() => { api.get("/quotes", { params: { status } }).then((r) => setList(r.data)); }, [status]);

  const shown = list.filter((x) => !q || `${x.number} ${x.title} ${customerName(x.customer)}`.toLowerCase().includes(q.toLowerCase()));

  return (
    <div>
      <PageHeader eyebrow="Pipeline" title="Quotes">
        <div className="relative"><Search className="absolute left-3 top-2.5 h-4 w-4 text-zinc-400" /><Input data-testid="quote-search-input" placeholder="Search quotes…" value={q} onChange={(e) => setQ(e.target.value)} className="w-64 bg-white pl-9" /></div>
        <Button data-testid="new-quote-button" onClick={() => navigate("/quotes/new")} className="bg-red-600 hover:bg-red-700"><Plus className="mr-1 h-4 w-4" />New quote</Button>
      </PageHeader>
      <div className="mb-4 flex gap-1">
        {FILTERS.map((f) => (
          <button key={f || "all"} data-testid={`quote-filter-${f || "all"}`} onClick={() => setStatus(f)}
            className={`rounded-md px-4 py-1.5 text-sm font-medium capitalize transition-colors ${status === f ? "bg-zinc-900 text-white" : "bg-white text-zinc-600 ring-1 ring-zinc-200 hover:ring-zinc-400"}`}>{f || "All"}</button>
        ))}
      </div>
      <div className="overflow-hidden rounded-lg border border-zinc-200 bg-white">
        <table className="w-full text-sm" data-testid="quotes-table">
          <thead className="border-b border-zinc-200 bg-slate-50 text-left font-mono text-[11px] uppercase tracking-wider text-zinc-500">
            <tr><th className="px-5 py-3">Number</th><th className="px-3">Customer</th><th className="px-3">Title</th><th className="px-3">Status</th><th className="px-3">Created</th><th className="px-3">Valid until</th><th className="px-5 text-right">Total inc GST</th></tr>
          </thead>
          <tbody>
            {shown.map((x) => (
              <tr key={x.id} data-testid={`quote-row-${x.number}`} onClick={() => navigate(`/quotes/${x.id}`)} className="cursor-pointer border-b border-zinc-100 last:border-0 hover:bg-slate-50">
                <td className="px-5 py-3 font-mono font-semibold">{x.number}</td>
                <td className="px-3 font-medium">{customerName(x.customer)}</td>
                <td className="px-3 text-zinc-500">{x.title}</td>
                <td className="px-3"><StatusBadge status={x.status} /></td>
                <td className="px-3 text-zinc-500">{fmtDate(x.created_at)}</td>
                <td className="px-3 text-zinc-500">{fmtDate(x.valid_until)}</td>
                <td className="px-5 text-right font-mono font-semibold">{money(x.total)}</td>
              </tr>
            ))}
            {!shown.length && <tr><td colSpan={7} className="px-5 py-10 text-center text-zinc-400">No quotes found.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
